
// -----------------Detail RENTER Action---------------

export const setDetailRenter = (renter) => {
    return (dispatch) => {
        dispatch({
            type: 'setDetailRenter',
            payload: renter
        })
    }
}

// -----------------Alert Actions-----------------

export const setAlert = (message, status) => {
    return (dispatch) => {
        dispatch({
            type: 'setAlert',
            payload: { message, status }
        })
    }
}

export const hideAlert = (message) => {
    return (dispatch) => {
        dispatch({
            type: 'hideAlert',
            payload: { message }
        })
    }
}

// -----------------Loading Actions-----------------

export const setLoading = (loading) => {
    return (dispatch) => {
        dispatch({
            type: 'setLoading',
            payload: loading
        })
    }
}

// for partner preview page
export const setPartnerPreviewPage = (page) => {
    return (dispatch) => {
        dispatch({
            type: 'setPartnerPreviewPage',
            payload: page
        })
    }
}

// for vehicle preview page
export const setVehiclePreviewPage = (page) => {
    return (dispatch) => {
        dispatch({
            type: 'setVehiclePreviewPage',
            payload: page
        })
    }
}

// for user accuont detail
export const setAccount = (user) => {
    return (dispatch) => {
        dispatch({
            type: 'setAccount',
            payload: user
        })
    }
}


// for Units preview page
export const setUnitPreviewPage = (page) => {
    return (dispatch) => {
        dispatch({
            type: 'setUnitPreviewPage',
            payload: page
        })
    }
}

// for Residents preview page
export const setResidentPreviewPage = (page) => {
    return (dispatch) => {
        dispatch({
            type: 'setResidentPreviewPage',
            payload: page
        })
    }
}


// for Guests preview page
export const setGuestPreviewPage = (page) => {
    return (dispatch) => {
        dispatch({
            type: 'setGuestPreviewPage',
            payload: page
        })
    }
}